const host = "https://imart.kinlong.in:9091";
const uatHost = "https://uat.kinlong.in:8081";

let api: any = {
    api_product_index: host + `/api/product/index`,
    api_product_index_uat: uatHost + `/api/product/index`, // UAT
    api_traveler_postMsg: host + `/api/traveler/postMsg`,
    api_product_productCategoryIndex: host + `/api/product/productCategoryIndex`,
    api_product_productCategoryIndex_uat: uatHost + `/api/product/productCategoryIndex`, // UAT
    api_user_career: host + `/api/kinlongwebsite/userCareer`,// Production
    api_user_career_uat: uatHost + `/api/kinlongwebsite/userCareer`, // UAT
    api_enquiry_submitMessage: host + `/api/kinlongwebsite/submitMessage`, // Production
    api_enquiry_submitMessage_uat: uatHost + `/api/kinlongwebsite/submitMessage` // UAT
};

export default api;
